<script>
import UserTypes from "@/constants/user_type";
// definir un objeto mixin
export default {
  data() {
    return {
      show: true,
      dialog: false,
      rowsPerPageItems: [50, 100],
      pagination: {
        page: 1,
        itemsPerPage: 50,
      },
      dialog_delete: false,
      search: "",
      rowNumber: 0,
      deleteIndex: 0,
      deleteId: 0,
      editedIndex: -1,
      viewdIndex: -1,
      loading: false,
      list: [],
      selected: [],
      cant_pages: 0,
      total: 0,
      current_page: 1,
      name_filter: "",
      active_filter: 1,
      open_filter: false,
      mainItem: null,
      loadingSubmit: false,
      expandedItems: [],
      
      // Ordenamiento por atributo principal
      sortByMainAttribute: false,
      sortDirection: 'asc', // 'asc' o 'desc'
    };
  },
  created: function () {
    window.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        var dialog_count = document.querySelectorAll("div.v-dialog");
        if (dialog_count.length == 1) {
          this.close();
        }
      }
      // Enter para buscar
      if (e.key === "Enter" && !this.isAnyDialogOpen() && this.service) {
          this.loadList(this.service);
      }
    });
  },
  computed: {
    formBtn() {
      if (this.editedIndex === -1 && this.viewdIndex === -1) {
        return "Crear";
      } else if (this.viewdIndex === -1) {
        return "Editar";
      }
      return "";
    },
    allExpanded() {
      return this.list.length > 0 && this.expandedItems.length === this.list.length;
    },
    // Computed properties para contador de paginación tradicional
    itemsPerPage() {
      return this.$store.state.config.items_per_page;
    },
    startItem() {
      return ((this.current_page - 1) * this.itemsPerPage) + 1;
    },
    endItem() {
      const calculated_end = this.current_page * this.itemsPerPage;
      return calculated_end > this.total ? this.total : calculated_end;
    },
    paginationText() {
      if (this.total === 0) return 'No hay resultados';
      return `Mostrando ${this.startItem} a ${this.endItem} de ${this.total} resultados`;
    }
  },
  mounted() {
    //console.log("client",JSON.parse(localStorage.getItem("app_object")).client)
  },
  methods: {
    loadPage(service) {
      this.loadList(service, (this.current_page - 1) * this.$store.state.config.items_per_page, this.$store.state.config.items_per_page);
    },
    isEmployee() {
      return localStorage.getItem("user_type") == UserTypes.EMPLOYEE || localStorage.getItem("user_type") == UserTypes.SUPERUSER;
    },
    isClient() {
      return localStorage.getItem("user_type") == UserTypes.CLIENT;
    },
    getAppObject() {
      return JSON.parse(localStorage.getItem("app_object"));
    },
    expandFilter() {
      if (this.open_filter) {
        this.open_filter = false;
      } else {
        this.open_filter = true;
      }
    },
    updateDialog(value) {
      if (!value) {
        this.close();
      }
      this.dialog = value;
    },
    updateDialogDelete(value) {
      this.dialog_delete = value;
    },
    isAnyDialogOpen() {
      return this.dialog || this.dialog_delete;
    },
    viewItem(item) {
      this.viewdIndex = this.list.indexOf(item);
      this.mainItem = Object.assign({}, item);
      this.dialog = true;
    },
    editItem(item) {
      this.editedIndex = this.list.indexOf(item);
      this.mainItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.deleteIndex = this.list.indexOf(item);
      this.deleteId = item.id;
      this.dialog_delete = true;
    },
    deleteItemConfirm() {
      this.delete(this.service);
      this.dialog_delete = false;
      this.loadList(this.service);
    },
    close() {
      this.mainItem = null;
      this.dialog = false;
      this.editedIndex = -1;
      this.viewdIndex = -1;
    },
    back() {
      this.$router.back();
    },
    updatePagination(pagination) {
      this.pagination = pagination;
    },
    getFilterParams() {
      var param = {};
      return param;
    },
    loadList(service) {
      this.loading = true;

      const param = {
        enable: true,
        from: this.current_page,
        limit: this.$store.state.config.items_per_page,
      };

      //agrego los parametros a param
      Object.assign(param, this.getFilterParams());

      this.open_filter = false;
      service
        .filter(param)
        .then((response) => {
          if (param.from == 0) {
            this.current_page = 1;
          }
          this.list = response.result.list;
          this.cant_pages = Math.ceil(response.result.total / this.$store.state.config.items_per_page);
          this.total = response.result.total;
          this.loading = false;

          if (typeof this.selected !== "undefined") {
            this.selected = [];
          }
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    delete(service) {
      this.loadingSubmit = true;
      service
        .remove({ id: this.deleteId })
        .then((response) => {
          if (response.status === true) {
            this.toast.success(response.msg);
            this.loadList(service);
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.toast.error(response.message);
            } else {
              this.toast.error(response.msg);
            }
          }
        })
        .catch((e) => {
          this.toast.error("Error exception");
        })
        .finally(() => {
          this.loadingSubmit = false;
        });
    },
    toggleExpand(index) {
      const i = this.expandedItems.indexOf(index);
      if (i > -1) {
        this.expandedItems.splice(i, 1);
      } else {
        this.expandedItems.push(index);
      }
    },
    isExpanded(index) {
      return this.expandedItems.includes(index);
    },
    toggleExpandAll() {
      if (this.allExpanded) {
        // Contraer todo
        this.expandedItems = [];
      } else {
        // Expandir todo
        this.expandedItems = [...Array(this.list.length).keys()];
      }
    },
    getPresentationTypeName(amount, presentationTypeId, presentationTypeName) {
      if (parseInt(amount) === 1) {
        return presentationTypeName;
      }
      const UNITS_ID = 1;
      const BOX_ID = 2;
      const PALLET_ID = 3;
      
      switch (parseInt(presentationTypeId)) {
        case UNITS_ID:
          return 'Unidades';
        case BOX_ID:
          return 'Cajas';
        case PALLET_ID:
          return 'Pallets';
        default:
          return '';
      }
    },
    sortItemsByMainAttribute(items, getAttributesFn) {
      if (!this.sortByMainAttribute || !items || items.length === 0) {
        return items;
      }
      
      // Clonar array para no mutar el original
      const sortedItems = [...items];
      
      // Orden de prioridad para agrupar por tipo de atributo
      const attributePriority = {
        'lote': 1,
        'serie': 2,
        'quality': 3,
        'storage_units_amount': 4,
        'expiration_date': 5,
        'descriptivo_1': 6,
        'descriptivo_2': 7,
        'descriptivo_3': 8
      };
      
      return sortedItems.sort((a, b) => {
        const attrsA = getAttributesFn(a);
        const attrsB = getAttributesFn(b);
        
        const attrA = this.getMainAttribute(attrsA);
        const attrB = this.getMainAttribute(attrsB);
        
        // Si alguno no tiene atributo, ponerlo al final
        if (!attrA && !attrB) return 0;
        if (!attrA) return 1;
        if (!attrB) return -1;
        
        // Primero agrupar por tipo de atributo (según prioridad)
        const priorityA = attributePriority[attrA.key] || 99;
        const priorityB = attributePriority[attrB.key] || 99;
        
        if (priorityA !== priorityB) {
          return priorityA - priorityB;
        }
        
        // Dentro del mismo tipo, ordenar por valor
        const valueA = String(attrA.value || '');
        const valueB = String(attrB.value || '');
        
        const comparison = valueA.localeCompare(valueB, undefined, { numeric: true, sensitivity: 'base' });
        
        return this.sortDirection === 'asc' ? comparison : -comparison;
      });
    },
    
    /**
     * Toggle del ordenamiento por atributo principal
     * Ciclo: sin ordenar -> ASC -> DESC -> sin ordenar
     */
    toggleMainAttributeSort() {
      if (!this.sortByMainAttribute) {
        // Activar ordenamiento ascendente
        this.sortByMainAttribute = true;
        this.sortDirection = 'asc';
      } else if (this.sortDirection === 'asc') {
        // Cambiar a descendente
        this.sortDirection = 'desc';
      } else {
        // Desactivar ordenamiento
        this.sortByMainAttribute = false;
      }
    },
  },
};</script>
